import {Component, Input, OnDestroy, OnInit} from '@angular/core';

@Component({
    selector: 'column-chart',
    templateUrl: './column-chart.component.html',
    styleUrls: ['./column-chart.component.scss'],
    standalone: false
})

export class ColumnChartComponent implements OnInit, OnDestroy {
  @Input() page;
  @Input() data;
  @Input() id;
  @Input() dataLabels;

  options = {
    series: [{ name: '', data: [] }],
    colors: ['#418AC9', '#1F4166'],
    chart: { height: 350, type: 'bar', },
    plotOptions: { bar: { borderRadius: 10, dataLabels: { position: 'top', }, } }, // top, center, bottom
    dataLabels: { enabled: true, offsetY: -20, style: { fontSize: '12px', colors: ['#C0C0C0'] } },
    xaxis: { categories: [], position: 'bottom', axisBorder: { show: false }, axisTicks: { show: false }, tooltip: { enabled: false } },
    yaxis: { axisBorder: { show: false }, axisTicks: { show: false, }, labels: { show: false }, tooltip: { enabled: false } }
  };

  chart;

  constructor() {
  }

  ngOnInit() {
    if (this.page === 'feedback') {
      const labels = [];
      let scaleMin = +this.data.scaleMin;
      const scaleMax = +this.data.scaleMax;
      const scaleStep = +this.data.scaleStep ? +this.data.scaleStep : 1;
      while (scaleMin <= scaleMax) {
        labels.push(scaleMin);
        scaleMin = scaleMin + scaleStep;
      }
      const result = {};
      for (let i = 0; i < labels.length; i++) {
        result[labels[i]] = 0;
      }
      if (this.data && this.data.data) {
        for (let i = 0; i < this.data.data.length; i++) {
          result[this.data.data[i]] = +result[this.data.data[i]] + 1;
        }
      }
      for (const key of Object.keys(result)) {
        this.options.xaxis.categories.push(key);
        this.options.series[0].data.push(result[key]);
      }
    } else {
      this.options.xaxis.categories = this.data.categories;
      this.options.series[0].data = this.data.data;
    }
    if (this.dataLabels) {
      this.options.dataLabels = this.dataLabels;
    }
    this.renderChart();
  }

  renderChart() {
    if (!document.querySelector('#column-chart_' + this.id)) {
      return setTimeout(() => {
        this.renderChart();
      }, 100);
    }
    if (document.querySelector('#column-chart_' + this.id)) {
      this.chart = new ApexCharts(document.querySelector('#column-chart_' + this.id), this.options);
      this.chart.render();
    }
  }

  ngOnDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
}
